import { OrderForm } from "./orderForm";
import { ModelViewer } from "./modelViewer";

import "../scss/style.scss";

function main() {
    let formContainer = document.querySelector("#ideolo3d-order-form");
    if (!formContainer) {
        return;
    }

    let modelViewer = new ModelViewer(formContainer.querySelector(".viewer-container")!);
    let orderForm = new OrderForm(
        formContainer.querySelector('form')!,
        modelViewer.supportedFormats(),
        async (model) => {
            if (!model) {
                modelViewer.clear();
                return;
            }

            try {
                await modelViewer.loadModel(model.file);
            } catch (error) {
                console.error(error);
            }
        }
    );
}

main();
